export enum TurnPhase {
  Play = "Play",
  Reveal = "Reveal",
  Shop = "Shop",
  CombatStart = "CombatStart",
  CombatEnd = "CombatEnd",
  EndGame = "EndGame",
  Cleanup = "Cleanup",
  RoundStart = "RoundStart",
}
